
    .responsive3208187990__root .TagSingleMulti635500568__root {
        gap: 8px 4px
    }
    
    .responsive3208187990__root .TagSingleMulti635500568__label {
        border-color: #cfd1dc;
        padding: 3px 8px;
    }

    .responsive3208187990__root .TagSingleMulti635500568__label.TagSingleMulti635500568--selected, .responsive3208187990__root .TagSingleMulti635500568__label.TagSingleMulti635500568--selected:focus-visible {
        border-color: #116dff;
    }

    .responsive3208187990__root .TagSingleMulti635500568__label:hover {
        border-color: #000624;
    }

    .responsive3208187990__root .TagSingleMulti635500568__label:focus-visible {
        border-color: #000624;
    }


/* st-namespace-reference="../../../../src/atoms/SelectionTags/TagSingleMulti.responsive.st.css" */